import { localStorageInstance } from '../instances/localStorageInstance';

export const REFRESH_TOKEN_STORAGE_KEY = 'refresh_token';

export function set(refreshToken: string): void {
  localStorageInstance.setItem(REFRESH_TOKEN_STORAGE_KEY, refreshToken);
}

export function get(): string {
  return localStorageInstance.getItem(REFRESH_TOKEN_STORAGE_KEY) || '';
}

export function remove(): void {
  return localStorageInstance.removeItem(REFRESH_TOKEN_STORAGE_KEY);
}
